import type { JSX, ReactNode } from 'react';

import styles from './Form.module.css';

interface FormGroupProps {
  children: ReactNode;
  className?: string;
}

function FormGroup({ children, className }: FormGroupProps): JSX.Element {
  return <div className={`${styles.FormGroup} ${className || ''}`}>{children}</div>;
}

export { FormGroup };
